import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Core2Config } from '../../shared/core2Config';
import { StockReplenishmentEventFilterSupplierModel } from '../../../../../../models/aggregates/erp/stock/stock-replenishment-event-filter-supplier.model';
import { BaseApiTemplateService } from '../../shared';


@Injectable({ providedIn: 'root' })
export class StockReplenishmentEventFilterSupplierService extends BaseApiTemplateService<StockReplenishmentEventFilterSupplierModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/stock-replenishment-event-filter-suppliers/backoffice-ep';

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/stock-replenishment-event-filter-suppliers/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/stock-replenishment-event-filter-suppliers/backoffice-ep';
    this.httpClient = theHttp;
  }

}
